import { render, staticRenderFns } from "./AzCompanyDetail.vue?vue&type=template&id=58e4b0b9&"
import script from "./AzCompanyDetail.vue?vue&type=script&lang=ts&"
export * from "./AzCompanyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AzCompanyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports